<template>
  <div class="admin-clients">
    <div class="panelheader border-1">
      <div class="title">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/admin/clients'}">{{pageName}}</el-breadcrumb-item>        
        </el-breadcrumb>
      </div>
      
      <div class="btn-wrapper">
        <el-button type="add" @click="onNewClient">New Client</el-button>  
      </div>

    </div>

      <div class="clients" v-if="!reloading">
        <div v-if="newClient">
          <newclient @close="onClose"></newclient>
        </div>
        <div v-else-if="editClient">
          <editclient :clientData="clientData" @close="onClose"></editclient>
        </div>
        <div v-else>
          <clienttable 
            @editClient="onEditClient" 
            @deleteClient="onDeleteClient">
          </clienttable>
        </div>
      </div>

      <div class="schedules" style="margin-top: 32px">
        <el-collapse v-model="activeCollapse" accordion>
          <el-collapse-item title="Schedules" name="1">

            <div> Total items scheduled: {{ formattedSchedules.length }} </div>
            <el-table
              :data="formattedSchedules"
              empty-text="Nothing scheduled."
              style="width: 100%"
              default-sort="time"
            >

              <el-table-column
                label="Booking ID"
                prop="booking_id"
                header-align="center"
                sortable
              >
                <template slot-scope="props">
                  {{ idColumn (props.row) }}
                </template>
              </el-table-column>

              <el-table-column
                label="On/Off"
                prop="on"
                header-align="center"
              >
                <template slot-scope="props">
                  <el-tag type="success" v-if="props.row.on">
                    ON
                  </el-tag>
                  <el-tag type="danger" v-else>
                    OFF
                  </el-tag>
                </template>
              </el-table-column>

              <el-table-column
                label="Time"
                prop="time"
                header-align="center"
                sortable
                :formatter="timeFormat"
              />

              <el-table-column
                label="Raw"
                prop="raw"
                header-align="center"
              />

            </el-table>
          </el-collapse-item>
        </el-collapse>
        <!-- {{ scheduleCounts(formattedSchedules) }} -->
      </div>
  </div>
</template>

<script>
  import auth from '../../../auth'
  import clienttable from './ClientTable.vue'
  import newclient from './NewClient.vue'
  import editclient from './EditClient.vue'
  import requests from '../../../requests'

  import dateFormat from 'dateformat'

  export default {
    name: 'admin-clients',
    data () {
      return {
        pageName: 'Clients Admin',
        clients:[],
        clientData: {},
        newClient: false,
        editClient: false,
        reloading: false,
        formattedSchedules: [],
        activeCollapse: null
      }
    },
    beforeMount () {
      requests.getSchedules(this, result => {
        this.formattedSchedules = result.map(booking => {
          const parts = booking.split('-')

          // Default data for each scheduler type
          const data = {
            on: parts[0] === 'on',
            time: new Date(parseInt(parts.slice(-1))), // Get the last part and turn it into a date
            raw: booking
          }

          if (parts[1][0] === 'b') { // Is a booking
            return {
              ...data, // concat defaults
              booking_id: parseInt(parts[1].slice(1)), // remove 'b'
            }
          } else {
            // site_id or field_id depending
            const id = {}
            if (parts[1][0] === 's') {
              id.site_id = parseInt(parts[1].slice(4)) // remove 'site'
            } else {
              id.field_id = parseInt(parts[1])
            }

            return {
              ...data, // concat defaults and id
              ...id,
              scene_id: parseInt(parts[2])
            }
          }
        })
      })
    },
    updated(){
      this.$nextTick(()=>{
        this.reloading = false;
      })
    },
    methods: {
      onNewClient() {
        this.editClient = false;
        this.newClient = true;
      },
      onEditClient(clientData) {
        this.clientData = clientData;
        
        this.newClient = false;
        this.editClient = true;
      },
      onDeleteClient(id) {
        var context = this;
        requests.deleteClient(this, id, function(result){
          console.log(result);
          context.reloading = true;
        })

      },
      onClose() {
        this.newClient = false;
        this.editClient = false;
      },
      scheduleCounts () {
        if (!this.formattedSchedules) return null

        return this.formattedSchedules.reduce((schedArr, schedule) => {
          if (schedArr.hasOwnProperty(schedule.booking_id)) { // Already has reference to booking, increase count
            schedArr[schedule.booking_id]++
          } else {
            if (schedule.booking_id !== undefined) { // If there is actually a booking_id, create a new entry
              schedArr[schedule.booking_id] = 1
            } else {
              if (schedArr.hasOwnProperty(schedule.raw)) { // Otherwise add the raw as key or increase
                schedArr[schedule.raw]++
              } else {
                schedArr[schedule.raw] = 1
              }
            }
          }
          return schedArr
        }, {})
      },
      timeFormat (time) {
        if (time.hasOwnProperty('time')) { // If sending the row (probably always)
          time = time.time
        }
        // Convert `Date()` to '2018/04/20 @ 16:20'
        return dateFormat(new Date(time), 'yyyy/mm/dd @ HH:MM')
      },
      idColumn (row) {
        if (row.booking_id) return row.booking_id
        if (row.site_id) return `Site: ${row.site_id} | Scene: ${row.scene_id}`
        if (row.field_id) return `Field: ${row.field_id} | Scene: ${row.scene_id}`
      }
    },
    components:{
      'clienttable':clienttable,
      'newclient':newclient,
      'editclient':editclient
    }
  }
</script>

<style>
  .clients{
    display: block;
    padding: 15pt;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// Clients.vue?660fa8fe